module.exports = __webpack_public_path__ + "img/fail.bcd1341e.png";